// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"299":"7825a21e","411":"71fe86c7","552":"da4439d6","672":"22deef91","761":"c9eda949","807":"6dd5bd35","932":"22deef91"}[chunkId] + ".chunk.css";
};